import { GroupHeader, Option, Permission, PermissionGroup } from '../types';

export function isPermissionGroup(
  arg: Permission | PermissionGroup,
): arg is PermissionGroup {
  return Array.isArray((arg as PermissionGroup).options);
}

export function isGroupHeader(arg: GroupHeader | Option): arg is GroupHeader {
  return (arg as GroupHeader).isGroupTitle === true || !arg.pillValue;
}
